"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.icon.help': 'Enter FontAwesome icon class (e.g., fas fa-folder)',
};
